export default __webpack_public_path__ + "static/icon-32-1-4081eae063e757029f6d00992291faf0.png";